import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Paragraph, FlexContainer, Button } from 'heliocor-ui'

import { CodeTextField } from '../../common'
import { AuthenticationLayout } from './authentication.styles'


const AuthenticationCode = ({email, sendEmail, backToEmail}) => {

    const { t } = useTranslation()
    const isRequest = useSelector(state => state.config.isRequest)
    const authenticated = useSelector(state => state.config.authenticated)
    const cafeStatus = useSelector(store => store.general.cafeStatus)

    const shouldRequestOTP = isRequest && !authenticated && !['PARTY_LOADED', 'READY', 'INVALID_ACTIVATION_CODE', 'LOADING'].includes(cafeStatus)

    if(shouldRequestOTP) {
        return (
            <AuthenticationLayout column padding='4rem' justifyContent='center' textAlign="center" >
                <Paragraph value={t('You need an OTP to continue the process:')} />
                <Button onClick={sendEmail} value={t('Request OTP')} fixDimension={{width: '18rem'}}/>
            </AuthenticationLayout>
        )
    }

    return (
        <AuthenticationLayout column padding='4rem' justifyContent='flex-start'>
            <CodeTextField />
            <Paragraph value={t('warning.emailSent')} />
            <FlexContainer alignItems='center'>
                <Paragraph value={t('warning.checkEmail')} />
                <Paragraph color='main' value={email} margin='0 0.3rem' data-cy='emailSentTo' />
            </FlexContainer>
            <FlexContainer height='2rem' alignItems='flex-end'>
                <Paragraph
                    data-cy="resend-code-button"
                    onClick={sendEmail}
                    cursor='pointer'
                    color='main'
                    value={t('resendCode')}
                    margin='0 1rem 0 0'
                />
                {!isRequest && (
                    <Paragraph
                        data-cy="change-email-button"
                        onClick={backToEmail}
                        cursor='pointer'
                        color='main'
                        value={t('changeEmail')}
                        margin='0 1rem 0 0'
                    />
                )}
            </FlexContainer>
        </AuthenticationLayout>
    )
}

export { AuthenticationCode }